import { render, staticRenderFns } from "./companyUser.vue?vue&type=template&id=0c9b0768&"
import script from "./companyUser.vue?vue&type=script&lang=js&"
export * from "./companyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports